<!--
 * @Description: 新增-编辑所有字段类型
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 单行文本，超链接 -->
  <jw-input v-if="fieldItem?.fieldType === 0 || fieldItem?.fieldType === 11 || fieldItem?.fieldType === 13" :max-length="fieldItem?.fieldType === 11 ? 1000 : 0" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :disabled="fieldItem?.disabled" class="system-form-item-fields" />
  <!-- 多行文本 -->
  <jw-textarea
    v-else-if="fieldItem?.fieldType == 1"
    :placeholder="fieldItem?.placeholder || fieldItem?.label"
    v-model="fieldItem.fieldValue"
    :auto-size="{
      minRows: 2,
      maxRows: 5
    }"
    :max-length="1000"
    :disabled="fieldItem?.disabled"
    :class="['system-form-item-fields']"
  />
  <!-- 单选按钮 -->
  <jw-radio-group v-else-if="fieldItem?.fieldType == 2 && fieldItem?.fieldExt" class="system-form-item-fields" v-model="fieldItem.fieldValue" :disabled="fieldItem?.disabled">
    <jw-radio v-for="item in JSON.parse(fieldItem?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
  </jw-radio-group>
  <!-- 多选按钮 -->
  <jw-checkbox-group v-else-if="fieldItem?.fieldType == 3 && fieldItem?.fieldExt" class="system-form-item-fields" v-model="fieldItem.fieldValue" :disabled="fieldItem?.disabled">
    <jw-checkbox v-for="item in JSON.parse(fieldItem?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
  </jw-checkbox-group>
  <!-- 下拉单选 -->
  <jw-select :trigger-props="{ updateAtScroll: true }" v-else-if="field.fieldType === 4 && fieldItem?.fieldExt" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" class="system-form-item-fields" :options="JSON.parse(fieldItem?.fieldExt)" popup-container=".system-form-item" allow-clear allow-search :disabled="fieldItem?.disabled"> </jw-select>
  <!-- 下拉多选 -->
  <jw-select :trigger-props="{ updateAtScroll: true }" v-else-if="field.fieldType === 5 && fieldItem?.fieldExt" :placeholder="fieldItem?.placeholder || fieldItem?.label" multiple class="system-form-item-fields" v-model="fieldItem.fieldValue" :options="JSON.parse(fieldItem?.fieldExt)" popup-container=".system-form-item" allow-search :disabled="fieldItem?.disabled"> </jw-select>
  <!-- 人员选择是一个单框与角色权限中的添加人员一样 -->
  <xl-tree-member-modal v-else-if="field.fieldType === 6" ref="xlTreeMember" :tree="tree" @cb="setModulesItem($event, fieldItem)" :depart="fieldItem?.fv?.departList" :user="fieldItem?.fv?.userList" :disabled="fieldItem?.disabled" :memberNumber="1" :multipleDep="false">
    <jw-input style="width: 100%" v-if="!fieldItem?.fieldValue" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" class="system-form-item-fields" />
    <jw-input-tag style="width: 100%" v-else v-model="fieldItem.fieldValue" class="system-form-item-fields" :max-tag-count="3" readonly :placeholder="fieldItem?.placeholder || fieldItem?.label" />
  </xl-tree-member-modal>
  <!-- 数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
  <template v-else-if="field.fieldType === 7">
    <jw-input-number v-if="fieldItem?.fieldExt === '100'" v-model="fieldItem.fieldValue" class="system-form-item-fields" :placeholder="fieldItem?.placeholder || fieldItem?.label" allow-clear hide-button :disabled="fieldItem?.disabled">
      <template #suffix> % </template>
    </jw-input-number>
    <jw-input-number v-else class="system-form-item-fields" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :precision="Number(JSON.parse(fieldItem?.fieldExt)?.numberFormat || 0)" :disabled="fieldItem?.disabled" />
  </template>
  <!-- 日期格式 -->
  <template v-else-if="field.fieldType === 8">
    <jw-date-picker style="width: 100%" v-if="fieldItem?.fieldExt == 'YYYY/MM/DD HH:mm' || fieldItem?.fieldExt == 'YYYY-MM-DD HH:mm'" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" show-time :value-format="fieldItem?.fieldExt" class="system-form-item-fields" :format="fieldItem?.fieldExt" popup-container=".system-form-item" position="br" :disabled="fieldItem?.disabled" @ok="onOk" />
    <jw-date-picker style="width: 100%" v-else v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" class="system-form-item-fields" :format="fieldItem?.fieldExt" popup-container=".system-form-item" position="br" :disabled="fieldItem?.disabled" />
  </template>
  <!-- 日期范围 -->
  <template v-else-if="field.fieldType === 9">
    <jw-range-picker v-if="fieldItem?.fieldExt === '0'" v-model="fieldItem.fieldValue" class="system-form-item-fields" :disabled="fieldItem?.disabled" popup-container=".system-form-item" />
    <jw-range-picker v-else-if="fieldItem?.fieldExt === '1'" class="system-form-item-fields" v-model="fieldItem.fieldValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" popup-container=".system-form-item" :disabled="fieldItem?.disabled" />
    <jw-range-picker v-else v-model="fieldItem.fieldValue" class="system-form-item-fields" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" popup-container=".system-form-item" :disabled="fieldItem?.disabled" />
  </template>
  <!-- 级联选择器 -->
  <jw-cascader :trigger-props="{ updateAtScroll: true }" v-else-if="field.fieldType === 10 && fieldItem?.fieldExt" :options="JSON.parse(fieldItem?.fieldExt)" :placeholder="fieldItem?.placeholder || fieldItem?.label" class="system-form-item-fields" v-model="fieldItem.fieldValue" :disabled="fieldItem?.disabled" path-mode allow-clear allow-search />
  <!-- 查找关联 -->
  <template v-else-if="field.fieldType === 12 || field.fieldType === 25">
    <jw-input v-if="fieldItem?.disabled" class="system-form-item-value" v-model="fieldItem.fieldValueName" disabled></jw-input>
    <xl-association v-else :multiple="field.fieldType === 25" :basic-data="{ fieldKey: field.value, id: props.id, entity: props.entity, relation: field?.fieldExt }" :modules-item="fieldItem" :form-data="{}" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" />
  </template>
  <!-- 金额 -->
  <template v-else-if="field.fieldType === 16">
    <jw-input-number :disabled="fieldItem?.disabled" class="system-form-item-fields" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :precision="Number(fieldItem?.fieldExt)" />
  </template>
  <!-- 附件 -->
  <template v-else-if="field.fieldType === 18 && fieldItem?.fieldExt">
    <xl-upload :accept="JSON.parse(fieldItem?.fieldExt)?.accept" :limit="JSON.parse(fieldItem?.fieldExt)?.limit" :placeholder="fieldItem?.placeholder || fieldItem?.label" v-model="fieldItem.fieldValue" :defaultFileList="fieldItem?.fieldValue" class="system-formlumns-item-value" @cb="setModulesItem($event, fieldItem)" :disabled="fieldItem?.disabled" />
  </template>
  <!-- 部门 -->
  <xl-tree-member-modal v-else-if="field.fieldType === 22" ref="xlTreeMember" :multipleDep="false" :tree="departmentTree" @cb="setModulesItem($event, fieldItem)" :depart="fieldItem?.fv?.departList" :user="fieldItem.fv?.userList" :disabled="fieldItem?.disabled">
    <jw-input style="width: 100%" v-if="!fieldItem?.fieldValue" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :disabled="fieldItem?.disabled ?? true" class="system-form-item-fields" />
    <jw-input-tag style="width: 100%" v-else v-model="fieldItem.fieldValue" class="system-form-item-fields" :max-tag-count="3" readonly :placeholder="fieldItem?.placeholder || fieldItem?.label" />
  </xl-tree-member-modal>
  <!-- 23百分比 -->
  <jw-input-number v-else-if="field.fieldType === 23" v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :min="0" :precision="Number(JSON.parse(fieldItem?.fieldExt)?.numberFormat || 0)" allow-clear class="system-form-item-fields" :disabled="fieldItem?.disabled">
    <template #append> % </template>
  </jw-input-number>
  <!-- 计算类型字段 -->
  <template v-else-if="field?.fieldType === 24">
    <!-- 数字（汇总累计) 金额（汇总累计) -->
    <jw-input v-model="fieldItem.fieldValue" placeholder="计算字段" disabled class="system-form-item-fields" />
  </template>
  <!-- 其他类型 -->
  <jw-input v-else v-model="fieldItem.fieldValue" :placeholder="fieldItem?.placeholder || fieldItem?.label" :disabled="fieldItem?.disabled" class="system-form-item-fields" />
</template>

<script setup>
import dayjs from 'dayjs';
import { ref, watch } from 'vue';

/**
 * field: {
 *   required: false,
 *   disabled: false,
 *   fieldType: 0,
 *   fieldValue: 'form表单绑定值',
 *   label: '字段名',
 *   value: '字段name',
 *   fieldValues: '下拉选择数组',
 *   fieldExt: '单选多选选项'
 * }
 */
const props = defineProps({
  field: {
    type: Object
  },
  id: {
    type: [String, Number],
    default: null
  },
  entity: {
    type: [String, Number],
    default: null
  }
});
const emits = defineEmits(['cb']);
const fieldItem = ref(props?.field);
const onOk = (dateString) => {
  console.log('onOk: ', dateString);
};
// 左侧列表选择激活态结束
const tree = ref({
  checkDepartment: false
});
const departmentTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const setModulesItem = ($event, modulesItem) => {
  //人员和附件
  // console.log($event, modulesItem)
  // emits('cb', $event, modulesItem);
  if (modulesItem?.fieldType === 18) {
    //附件
    getFiles($event, modulesItem);
  } else {
    getVal($event, modulesItem); //人员和部门
  }
};

// 获取文件列表
const getFiles = (files, modulesItem) => {
  console.log('getFiles', files, modulesItem);
  const filesList = [];
  files &&
    files.length > 0 &&
    files?.forEach((v) => {
      if (v.response) {
        const url = v.response?.data;
        filesList.push(...url);
      } else {
        filesList.push({ name: v.name, url: v.url });
      }
    });
  modulesItem.fieldValue = filesList;
};
// 添加人员角色--获取部门或者用户的值
const getVal = async (v, modulesItem) => {
  console.log(v, modulesItem);
  if (modulesItem?.fieldType === 22) {
    modulesItem['fv'] = {
      departList: v?.departList
    };
    modulesItem.fieldValue = v?.departList?.map((u) => u.departmentName);
  } else {
    modulesItem['fv'] = {
      userList: v?.userList
    };
    modulesItem.fieldValue = v?.userList?.map((u) => u.userName);
  }
};
watch(
  () => fieldItem.value,
  () => {
    console.log('fieldItem: ', fieldItem);
    emits('cb', fieldItem.value);
  },
  { deep: true }
);
</script>

<style scoped lang="less">
@import './xl-field.less';
</style>
